import utils from 'utils'

class redInkConfirmFormChooseUkeyModal {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $filter, $uibModalInstance, $stateParams, items1) {
        $scope.title = items1.title
        $scope.tips = items1.tips
        $scope.ukeyList = $scope.userInfo.tax4UkeyList
        $scope.ukeyId = items1.ukeyId?items1.ukeyId:$scope.ukeyList[0].ukeyId
        console.log(items1.ukeyId)
        console.log($scope.ukeyList[0].ukeyId)

        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.ok = function () {
            if (!$scope.ukeyId) return logger.logError('请选择开票点')
            $uibModalInstance.close($scope.ukeyId)
        }
    }
}

redInkConfirmFormChooseUkeyModal.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$filter', '$uibModalInstance', '$stateParams', 'items1']
export default redInkConfirmFormChooseUkeyModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/redInkConfirmFormChooseUkeyModal.js